import React from 'react';
import { Box, Flex } from 'rebass';
import styled, { css } from 'styled-components';
import { FiUsers } from 'react-icons/fi';

import { InformationTooltip } from 'components/InformationTooltip';
import helpers from 'utils/helpers';

import { GoLink } from '../GoLink';

const colors = {
    purple: {
        background: '#eadefc',
        color: '#4003bd'
    },
    yellow: {
        background: '#FFFAF0',
        color: '#F2A001'
    },
    green: {
        background: '#F0FFF3',
        color: '#0A7723'
    },
    blue: {
        background: '#D1E9FF',
        color: '#0035C9'
    }
};

const Icon = styled.span`
    border-radius: 4px;
    display: inline-block;
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    text-align: center;
    font-size: 12px;
    vertical-align: top;

    ${props => css`
        background: ${colors[props.color] ? colors[props.color].background : '#eadefc'};
        color: ${colors[props.color] ? colors[props.color].color : '#4003bd'};
    `}
`;

/**
 * Dashboard statistic
 *
 * @param {Object} props Props
 * @param {string} props.title Title of the statistic
 * @param {number} props.value Value of the statistic
 * @param {string} props.to Link
 * @param {blue|purple|yellow|green} props.iconColor Color of the icon
 * @param {string} props.extraInfo Extra info to be displayed in a tooltip
 * @returns {React.Component} The component
 */
export function Statistic({ title, value, to, iconColor, extraInfo }) {
    return (
        <Box className="basic-card" p="24px" width="100%">
            <Flex mb={16} height="24px" alignItems="center" sx={{ gap: '8px' }}>
                <Icon color={iconColor}>
                    <FiUsers />
                </Icon>
                <Box
                    as="p"
                    lineHeight="24px"
                    sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                    className="bold text-primary fs-16"
                >
                    {title}
                </Box>
                {extraInfo && (
                    <InformationTooltip id={`${title.split(' ').join('-')}-tooltip`}>{extraInfo}</InformationTooltip>
                )}
            </Flex>
            <Box as="p" mb={16} sx={{ fontSize: '48px', lineHeight: '56px' }} className="bold text-primary">
                {helpers.numberWithCommas(value)}
            </Box>
            {/*<GoLink to={to}>Go to the list</GoLink>*/}
        </Box>
    );
}

export default Statistic;
